<template>
  <div>
    <v-dialog v-model="open" persistent max-width="1035" scrollable>
      <v-card tile :disabled="savedLists.loading">
        <v-toolbar>
          <v-spacer></v-spacer>
          <v-toolbar-title
            class="headline font-weight-bold text-center px-md-10"
          >
            Save to a List
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="onClose">
            <v-icon color="black" large>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text class="card-list">
          <v-list v-if="savedLists.data.length > 0" :disabled="loading">
            <v-list-item-group color="bluelink" @change="onChange">
              <template v-for="list in savedLists.data">
                <v-list-item :key="`item-${list.id}`" :value="list">
                  <v-list-item-content>
                    <v-list-item-title v-text="list.name"></v-list-item-title>
                    <v-list-item-subtitle>
                      ({{ list.items.length }} items)
                    </v-list-item-subtitle>
                  </v-list-item-content>
                  <v-list-item-action
                    v-if="loading && selectedList === list.id"
                  >
                    <v-progress-circular
                      indeterminate
                      color="primary"
                    ></v-progress-circular>
                  </v-list-item-action>
                </v-list-item>
                <v-divider :key="`divider-${list.id}`"></v-divider>
              </template>
            </v-list-item-group>
          </v-list>
          <v-row
            v-else-if="savedLists.loading"
            justify="center"
            align="center"
            class="empty-state"
          >
            <v-progress-circular
              indeterminate
              size="50"
              color="primary"
            ></v-progress-circular>
          </v-row>
          <v-row v-else justify="center" align="center" class="empty-state">
            <v-col cols="12" md="6" class="text-center">
              <h4 class="text-h4 font-weight-medium text-center mb-2">
                Nothing Saved
              </h4>
              <p class="mb-7 body-1">
                Create lists of inspiration. Save activities, plans, and blog
                posts for later.
              </p>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="justify-center py-6 d-flex">
          <v-btn
            color="bluelink"
            text
            class="text-none"
            @click="createOpen = true"
          >
            <v-icon left>mdi-plus-circle</v-icon>
            <span>Create a new list</span>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <create-new-list-dialog
      v-if="createOpen"
      :open="createOpen"
      hide-overlay
      @submit="onCreateSubmit"
      @close="createOpen = false"
    ></create-new-list-dialog>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import CreateNewListDialog from './CreateNewListDialog.vue'

export default {
  components: { CreateNewListDialog },
  props: {
    open: {
      type: Boolean,
      required: true,
    },
    resourceId: {
      type: Number,
      required: true,
    },
    category: {
      type: String,
      default: 'activity',
    },
  },
  data() {
    return {
      selectedList: null,
      createOpen: false,
    }
  },
  computed: {
    ...mapState('lists', ['savedLists']),
    ...mapState('user', ['loading']),
  },
  mounted() {
    this.$store.dispatch('lists/SAVED_LIST/REQUEST')
  },
  methods: {
    onClose() {
      this.$emit('close')
    },
    onChange(list) {
      this.selectedList = list.id

      this.$store
        .dispatch('user/FAVORITE/REQUEST', {
          action: 'add',
          category: this.category,
          favorite_list_id: list.id,
          object_id: this.resourceId,
        })
        .then(() => {
          this.$emit('added', list)
        })
    },
    onCreateSubmit() {
      this.createOpen = false

      this.$store.dispatch('lists/SAVED_LIST/REQUEST')
    },
  },
}
</script>

<style>
.card-list {
  height: 20rem;
}

.empty-state {
  height: 100%;
}
</style>
